import React, { useState, useEffect } from 'react';

export default function SelectFilter({ value, operator, onChange, options }) {
  const [localVal, setLocalVal] = useState(value);
  const [op, setOp] = useState(operator || 'contiene');

  useEffect(() => { setLocalVal(value); }, [value]);
  useEffect(() => { setOp(operator || 'contiene'); }, [operator]);

  const opts = (options || []).map(o =>
    typeof o === 'string' ? o : (o.label || o.value || String(o))
  );

  const handleValueChange = (e) => {
    setLocalVal(e.target.value);
    onChange(e.target.value, op);
  };

  const handleOpChange = (e) => {
    setOp(e.target.value);
    onChange(localVal, e.target.value);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <select
        className="cm-filter-select"
        value={localVal}
        onChange={handleValueChange}
      >
        <option value="">Seleccione una opción</option>
        {opts.map((opt, i) => (
          <option key={i} value={opt}>{opt}</option>
        ))}
      </select>
      <select className="cm-filter-select" value={op} onChange={handleOpChange}>
        <option value="contiene">Contiene</option>
        <option value="igual">Igual</option>
        <option value="diferente">Diferente</option>
      </select>
    </div>
  );
}
